import React, { useState, useEffect } from 'react';
import Layout from 'Component/Layouts/layout';
import { Box, Card, Button, Grid } from '@mui/material';
import congoImg from 'assets/congo.png';
import { useNavigate, useParams } from 'react-router-dom';
import useApiCaller from 'hooks/apiCaller';
import Loader from 'Component/Loader';
import CertificateDownloader from 'Component/Certificate/CertificateDownloader';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { COMPANY_ROLES } from 'Constants/roles';
import { toast } from 'react-toastify';

const CongratulationScreen = () => {
  const navigate = useNavigate();
  const params = useParams();
  const courseId = params.id;
  const uniqueCourseKeyInEmployeeCourses = params.uniqueCourseKeyInEmployeeCourses;

  const apiCaller = useApiCaller();
  const [result, setResult] = useState({
    score: '',
    passingScore: '',
    remainingAttempts: '',
    latestAttemptAnswers: [],
    correctAnswers: {},
  });
  const [answerArr, setAnswerArr] = useState([]);
  const [pass, setPass] = useState(false);
  const [loader, setLoader] = useState(true);
  const { employeeName, companyId, employeeId } = useSelector((state) => state.authSlice.userData);
  const { courseTitle } = useSelector((state) => state.detailsCourse.data);

  const handleGoHome = () => {
    navigate('/');
  };
  const handleReTakeTest = () => {
    navigate(`/questionnaire/${courseId}/${uniqueCourseKeyInEmployeeCourses}`);
  };

  const handleGetResult = async () => {
    const requestData = {
      courseId,
      uniqueCourseKeyInEmployeeCourses,
    };

    try {
      const response = await apiCaller.post('/user/userResults', requestData);
      const resData = response?.data?.data;

      if (!resData) return;

      const {
        score,
        passingScore,
        remainingAttempts,
        correctAnswers,
        latestAttemptAnswers,
        results,
      } = resData;
      setResult((prev) => ({
        ...prev,
        score,
        passingScore,
        remainingAttempts,
        latestAttemptAnswers,
        correctAnswers,
      }));

      setAnswerArr(results);
      const passed = score >= passingScore;
      setPass(passed);
      if (!passed) {
        toast.error('Test failed. Redirecting to courses in 3 seconds...', {
          theme: 'colored',
          autoClose: 3000,
        });
        setTimeout(() => navigate('/courses'), 3000);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    handleGetResult();
  }, []);

  if (loader) {
    return (
      <Layout>
        <Loader
          style={{
            height: '100vh',
            display: 'grid',
            placeItems: 'center',
          }}
        />
      </Layout>
    );
  }
  return (
    <Layout>
      {pass ? (
        <Box
          sx={{
            fontSize: '24px',
            fontWeight: 500,
            background: 'linear-gradient(to bottom, #E9FBE0 0%, #E6F0E8 100%)',
            position: 'relative',
            textAlign: 'center',
          }}
          className="p-2"
        >
          <Box sx={{ marginTop: 2 }}>
            <img src={congoImg} alt="Congratulations" />
          </Box>
          <Box sx={{ fontSize: 24, fontWeight: 500 }}>Congratulations!</Box>
          <Box sx={{ fontSize: 16, fontWeight: 400, marginBottom: 4 }}>
            You have cleared the learning
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            fontSize: '24px',
            fontWeight: 500,
            background: 'linear-gradient(to bottom, #FBE0E0 0%, #F0E6E6 100%)',
            position: 'relative',
            textAlign: 'center',
          }}
          className="p-2"
        >
          <Box sx={{ marginTop: 2 }}>{/* <img src={failImg} alt="Failed" /> */}</Box>
          <Box sx={{ fontSize: 24, fontWeight: 500 }}>Better Luck Next Time!</Box>
          <Box sx={{ fontSize: 16, fontWeight: 400, marginBottom: 4 }}>
            Unfortunately, you did not pass.
          </Box>
        </Box>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
        <Card sx={{ padding: 4, minWidth: 210, marginRight: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ color: '#706C84', fontSize: 16, fontWeight: 400 }}>Your Score</Box>
            <Box sx={{ fontSize: 24, fontWeight: 500 }}>{result.score}</Box>
          </Box>
        </Card>
        <Card sx={{ padding: 4, width: 210, marginRight: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ color: '#706C84', fontSize: 16, fontWeight: 400 }}>Passing Score</Box>
            <Box sx={{ fontSize: 24, fontWeight: 500, marginRight: 2 }}>{result.passingScore}</Box>
          </Box>
        </Card>
        <Card sx={{ padding: 4, width: 210 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ color: '#706C84', fontSize: 16, fontWeight: 400 }}>Remaining Attempts</Box>
            <Box sx={{ fontSize: 24, fontWeight: 500 }}>{result.remainingAttempts}</Box>
          </Box>
        </Card>
      </Box>
      <Box className="p-4">
        <table className="table table-bordered table-striped text-center">
          <thead>
            <tr>
              <th scope="col">Question</th>
              {COMPANY_ROLES.SATIN_FINSERV_LTD === companyId && <th scope="col">Correct Answer</th>}
              <th scope="col">Employee Answer</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {answerArr.map((val, index) => {
              return (
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Question {index + 1}</td>
                  {COMPANY_ROLES.SATIN_FINSERV_LTD === companyId && (
                    <td>{result.correctAnswers[index + 1]}</td>
                  )}
                  <td>{result.latestAttemptAnswers[index]}</td>
                  <td>
                    <button
                      type="button"
                      style={{
                        borderRadius: 20,
                        padding: '0px 20px',
                        border: 'none',
                        background: val === true ? '#E3FFE7' : '#FFCACA',
                        color: val === true ? '#09A522' : '#FF0000',
                      }}
                    >
                      {val === true ? 'correct' : 'wrong'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', gap: '10px' }}>
        <Box>
          <Button
            variant="outlined "
            size="medium"
            sx={{
              borderRadius: 50,
              fontSize: 12,
              border: '1px solid #2800B1',
              width: '100%',
              color: '#706C84',
            }}
            onClick={handleGoHome}
          >
            Back Home
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="medium"
            sx={{
              borderRadius: 50,
              background: '#2800B1',
              fontSize: 12,
              border: '1px solid #2800B1',
              width: '100%',
            }}
            onClick={() => handleReTakeTest()}
            disabled={result.remainingAttempts === 0 || pass}
          >
            Re-Take Test
          </Button>
        </Box>

        {/* download button */}
        {pass && companyId === COMPANY_ROLES.SATIN_FINSERV_LTD ? (
          <Box>
            <CertificateDownloader
              name={employeeName}
              courseName={courseTitle}
              date={dayjs().toISOString()} // use ISO string only
            />
          </Box>
        ) : null}
      </Box>
    </Layout>
  );
};

export default CongratulationScreen;
